module.exports = __webpack_public_path__ + "img/edward_live.082afcd3.jpg";